import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
const META_PIXEL_ID = '1646047029636178';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
const UTMIFY_PIXEL_ID = '6a5d5ba1653997e0edbec286';
type TrackingWindow = Window & {
  fbq?: MetaPixelFunction;
  _fbq?: MetaPixelFunction;
  pixelId?: string;
};
function loadMetaPixel() {
  const metaWindow = window as TrackingWindow;
  if (metaWindow.fbq) return;
  const pixel = function (...args: unknown[]) {
    if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
  } as MetaPixelFunction;
  pixel.queue = [];
  pixel.push = (...args: unknown[]) => pixel.queue.push(args);
  pixel.loaded = true;
  pixel.version = '2.0';
  metaWindow.fbq = pixel;
  metaWindow._fbq = pixel;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.dataset.metaPixel = 'true';
  document.head.appendChild(script);
  pixel('init', META_PIXEL_ID);
  pixel('track', 'PageView');
}
function loadUtmifyPixel() {
  if (document.querySelector('script[data-utmify-pixel="true"]')) return;
  const trackingWindow = window as TrackingWindow;
  trackingWindow.pixelId = UTMIFY_PIXEL_ID;
  const script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
  script.dataset.utmifyPixel = 'true';
  document.head.appendChild(script);
}
export function App() {
  useEffect(() => {
    loadMetaPixel();
    loadUtmifyPixel();
  }, []);
  return <LandingPage data-id="element-0" data-mp="3dlwa6guh8ldp" />;
}